import React, { FC, useContext, useEffect } from "react";
import "./style.scss";
import cn from "clsx";
import { useTranslation } from "react-i18next";
import { isWindows } from "react-device-detect";
import { getQuantityList } from "@/util/add-to-cart";

import useIsProductSingleSize from "@/components/product/hooks/useIsProductSingleSize";
import CustomDropdown from "@/components/customDropdown";
import { productErrorContext } from "../webSizes/productWebSizes";
import { convertToLabelValue } from "@/util";
import { ProductWebQuantityProps } from "./types";

const ProductQuantity: FC<ProductWebQuantityProps> = ({
  product,
  selectedSize,
  setSelectedQty,
  selectedQty
}) => {
  const { selectSizeFirstError, setSelectSizeFirstError } =
    useContext(productErrorContext);
  const { t } = useTranslation("productDetails");
  const productIsSingleSize = useIsProductSingleSize(product);
  const allowedQuantity = selectedSize?.sizeStock;
  const quantityList = getQuantityList(allowedQuantity) || [1];
  const selectedItemQuantity = quantityList.length ? selectedQty : 1;

  const handleSelectSizeFirst = (): void => {
    setSelectSizeFirstError(Boolean(product.pstock) && !selectedSize.size);
  };

  useEffect(() => {
    const isQtyNeedToBeReset =
      selectedSize?.sizeId && selectedQty > selectedSize?.sizeStock;

    if (selectedSize?.sizeId && selectSizeFirstError) {
      setSelectSizeFirstError(false);
    }
    if (isQtyNeedToBeReset) {
      setSelectedQty(1);
    }
  }, [selectedSize?.sizeId]);

  return (
    <>
      <div className="quantity">
        {Boolean(product.pstock) && (
          <em
            className={
              selectedSize?.size || productIsSingleSize
                ? "displayNone"
                : "selectSizeFirst"
            }
            onClick={handleSelectSizeFirst}
          />
        )}
        <span className="qty_text">{`${t("qty")}.`}</span>
        <CustomDropdown
          data={convertToLabelValue(quantityList)}
          selectedItem={convertToLabelValue(selectedItemQuantity)}
          handleChange={item => setSelectedQty(+item.value)}
          containerClass={cn("quantity_dropdown", {
            not_toggle_dropdown:
              quantityList.length > 0 && !Boolean(product.pstock)
          })}
          scrollbarMaxHeight={150}
          dropdownClass={cn("quantity_scrollbar", {
            windows_scrollbar: isWindows
          })}
        />
      </div>
    </>
  );
};

export default ProductQuantity;
